import { RowEditAndDelete } from 'components/icons/RowEditAndDelete';

export const columnsDataHierarquiaComercial = [
	{
		Header: ' ',
		accessor: 'CheckBox',
		disableSortBy: true,
		type: 'checkBox',
		filter: false,
	},
	{
		Header: 'Cód. Hierarquia',
		accessor: 'code',
		type: 'nullableTag',
		optional: true,
		filter: 'includesIgnoreCase',
	},
	{
		Header: 'Mercado',
		accessor: 'nomeMercado',
		type: 'nullableTag',
		createable: true,
		filter: 'includesIgnoreCase',
	},
	{
		Header: 'Canal de Venda',
		accessor: 'canalVenda',
		type: 'nullableTag',
		optional: true,
		createable: true,
		dependesOn: 'nomeMercado',
		filter: 'includesIgnoreCase',
	},
	{
		Header: 'Força de Venda',
		accessor: 'forcaVenda',
		type: 'nullableTag',
		dependsOnCreateable: true,
		dependesOn: 'canalVenda',
		filter: 'includesIgnoreCase',
	},
	{
		Header: 'Zona de Venda',
		accessor: 'zonaVenda',
		type: 'nullableTag',
		optional: true,
		dependsOnCreateable: true,
		dependesOn: 'canalVenda',
		filter: 'includesIgnoreCase',
	},
	{
		Header: 'Membro',
		accessor: 'membro',
		type: 'nullableTag',
		optional: true,
		dependesOn: 'zonaVenda',
		filter: 'includesIgnoreCase',
	},
	{
		Header: 'Data Registro',
		accessor: 'dataRegistro',
		type: 'date',
		optional: true,
		filter: 'includesIgnoreCase',
	},
	{
		Header: ' ',
		type: 'jsx',
		accessor: 'button',
		jsx: RowEditAndDelete,
		filter: false,
	},
];
